"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrgSwitcher = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Room = _interopRequireDefault(require("@material-ui/icons/Room"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _GpsFixed = _interopRequireDefault(require("@material-ui/icons/GpsFixed"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _notistack = require("notistack");

var _Grid = _interopRequireDefault(require("../Grid"));

var _Button = _interopRequireDefault(require("../Button"));

var _List = _interopRequireDefault(require("../List"));

var _SearchInput = _interopRequireDefault(require("../SearchInput"));

var _Dialog = _interopRequireDefault(require("../Dialog"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Drawer = _interopRequireDefault(require("../Drawer"));

var _SkeletonLoader = _interopRequireDefault(require("../SkeletonLoader"));

var _OrganizationHelper = require("../Utilities/OrganizationHelper");

var _lodash = require("lodash");

var _useLocalStorageState3 = require("../Utilities/useLocalStorageState");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    root: {
      textTransform: "none",
      letterSpacing: "normal"
    },
    icon: {
      lineHeight: 0
    },
    header: {
      flexGrow: 1
    },
    list: {
      "& .prmbl-listItem.prmbl-button": {
        textTransform: "none",
        letterSpacing: "normal"
      }
    },
    dialogContent: {
      padding: theme.spacing(1, 0, 3, 0)
    },
    contentWrapper: {
      padding: theme.spacing(0, 2, 2, 2)
    },
    searchMapIcon: {
      color: theme.palette.text.secondary,
      marginRight: theme.spacing(1)
    },
    drawerHeader: {
      padding: theme.spacing(2, 2, 0, 2)
    },
    drawer: {
      paddingBottom: theme.spacing(2)
    },
    searchIcon: {
      display: "flex",
      marginLeft: theme.spacing(1)
    }
  };
});

var OrgSwitcher = function OrgSwitcher(props) {
  var _props$showRecentOrga;

  var orgServiceSdk = props.orgServiceSdk,
      onOrgSelect = props.onOrgSelect,
      currentOrg = props.currentOrg,
      pageType = props.pageType,
      showGeolocation = props.showGeolocation,
      onError = props.onError;
  var classes = useStyles();
  var theme = (0, _ThemeHelper.useTheme)();

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var isMobileView = (0, _useMediaQuery.default)(theme.breakpoints.down("sm"));

  var _useState = (0, _react.useState)(currentOrg),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentOrganization = _useState2[0],
      setCurrentOrganization = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      tmpOrganization = _useState4[0],
      setTmpOrganization = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      modifyOrganizationOpen = _useState6[0],
      setModifyOrganizationOpen = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      searchResults = _useState8[0],
      setSearchResults = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 1),
      savedLocations = _useState10[0];

  var _useLocalStorageState = (0, _useLocalStorageState3.useLocalStorageState)("prmbl-recentOrganizations", [], (_props$showRecentOrga = props.showRecentOrganizations) !== null && _props$showRecentOrga !== void 0 ? _props$showRecentOrga : false),
      _useLocalStorageState2 = (0, _slicedToArray2.default)(_useLocalStorageState, 2),
      recentLocations = _useLocalStorageState2[0],
      setRecentLocations = _useLocalStorageState2[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      userOrganizations = _useState12[0],
      setUserOrganizations = _useState12[1];

  var _useState13 = (0, _react.useState)(currentOrg === undefined),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      isLoading = _useState14[0],
      setLoading = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      isError = _useState16[0],
      setError = _useState16[1];

  var isSuperUser = orgServiceSdk.IsInRole("superuser");
  var updateRecentLocations = (0, _react.useCallback)(function (organization) {
    var newLocations = (0, _toConsumableArray2.default)(recentLocations === undefined ? [] : recentLocations).map(function (item) {
      return _objectSpread({}, item);
    });
    var indexInRecents = newLocations.findIndex(function (x) {
      return x.id === organization.id || x.name === organization.name;
    });

    if (indexInRecents > -1) {
      newLocations = [].concat((0, _toConsumableArray2.default)(newLocations.slice(0, indexInRecents).map(function (item) {
        return _objectSpread({}, item);
      })), (0, _toConsumableArray2.default)(newLocations.slice(indexInRecents + 1).map(function (item) {
        return _objectSpread({}, item);
      })));
    }

    newLocations.unshift(organization);
    setRecentLocations(newLocations.slice(0, 5));
  }, [recentLocations, setRecentLocations]);
  var handleGetOrganizations = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(filters) {
      var orgList;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!isSuperUser) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return orgServiceSdk.GetOrganizationList(filters);

            case 4:
              orgList = _context.sent;
              _context.next = 10;
              break;

            case 7:
              _context.next = 9;
              return orgServiceSdk.GetUserOrganizationList(filters);

            case 9:
              orgList = _context.sent;

            case 10:
              return _context.abrupt("return", orgList);

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);

              if (onError) {
                onError(_context.t0);
              } else {
                enqueueSnackbar("We couldn't fetch the organizations list. It may be due to some network instability. Try again later.", {
                  variant: "error"
                });
              }

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [enqueueSnackbar, isSuperUser, onError, orgServiceSdk]);
  var handleSetOrganization = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(organization) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setCurrentOrganization(organization);
              updateRecentLocations(organization);
              onOrgSelect && onOrgSelect(organization);
              handleCloseEditLocation();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [onOrgSelect, updateRecentLocations]); // Create a button for a specific organization

  var mapOrgButton = (0, _react.useCallback)(function (organization) {
    var formattedName = (0, _OrganizationHelper.formatOrgName)(organization, organization.name);
    return {
      itemIcon: /*#__PURE__*/_react.default.createElement(_Room.default, null),
      itemText: {
        primary: formattedName,
        secondary: organization.name !== formattedName ? organization.name : undefined
      },
      button: true,
      onClick: function onClick() {
        return handleSetOrganization(organization);
      }
    };
  }, [handleSetOrganization]);
  var mapRecentOrgButton = (0, _react.useCallback)(function (organization) {
    var defaultMapOrgButton = mapOrgButton(organization);
    return _objectSpread(_objectSpread({}, defaultMapOrgButton), {}, {
      "data-testid": "recentOrganization-".concat(organization.id)
    });
  }, [mapOrgButton]);

  var _useState17 = (0, _react.useState)(""),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      searchValue = _useState18[0],
      setSearchValue = _useState18[1];

  var handleEditLocation = function handleEditLocation() {
    // Reset the search when opening dialog
    setSearchValue("");
    setModifyOrganizationOpen(true);
  };

  var handleCloseEditLocation = function handleCloseEditLocation() {
    return setModifyOrganizationOpen(false);
  };

  var onSearchChange = function onSearchChange(e) {
    setSearchValue(e.target.value);
  };

  var handleSearchRequest = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(search) {
      var orgs, renderedButtons, itemsOrdered;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (orgServiceSdk) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", false);

            case 2:
              if (!(search !== "" || search !== undefined)) {
                _context3.next = 8;
                break;
              }

              _context3.next = 5;
              return handleGetOrganizations({
                search: search
              });

            case 5:
              orgs = _context3.sent;

              if (orgs && orgs.items && orgs.items.length > 0) {
                itemsOrdered = orgs.items.sort(function (a, b) {
                  return (a.friendlyName || a.name).localeCompare(b.friendlyName || b.name);
                });
                renderedButtons = itemsOrdered.map(mapOrgButton);
              } else {
                renderedButtons = [{
                  itemText: {
                    primary: orgs && orgs.items ? "We couldn't find any organization with that name." : "There was a technical problem, please try again later."
                  },
                  button: false
                }];
              }

              setSearchResults(renderedButtons);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSearchRequest(_x3) {
      return _ref3.apply(this, arguments);
    };
  }(); // Use the dependencies from the function inside of debounce
  // eslint-disable-next-line react-hooks/exhaustive-deps


  var debounceSearch = (0, _react.useCallback)((0, _lodash.debounce)(handleSearchRequest, 300), [handleGetOrganizations, mapOrgButton, orgServiceSdk]);
  var renderedListItems = [];

  var savedLocationsHeader = /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    className: classes.header
  }, "Saved Organizations"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    variant: "text",
    onClick: handleCloseEditLocation
  }, "Manage")));

  var userOrganizationsFiltered = (0, _react.useMemo)(function () {
    return userOrganizations.sort(function (a, b) {
      return (a.friendlyName || a.name).localeCompare(b.friendlyName || b.name);
    }).filter(function (item) {
      return item.id !== (tmpOrganization === null || tmpOrganization === void 0 ? void 0 : tmpOrganization.id);
    });
  }, [tmpOrganization === null || tmpOrganization === void 0 ? void 0 : tmpOrganization.id, userOrganizations]);

  if (searchValue === "") {
    // If there is no search value present, render the current location option
    var handleUseCurrentLocation = function handleUseCurrentLocation() {
      setLoading(true);
      navigator.geolocation.getCurrentPosition( /*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(position) {
          var geo, possibleLocalities;
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  geo = {
                    Latitude: position.coords.latitude,
                    Longitude: position.coords.longitude,
                    distance: 100
                  };
                  _context4.next = 3;
                  return handleGetOrganizations({
                    pageSize: 1,
                    geolocation: geo
                  });

                case 3:
                  possibleLocalities = _context4.sent;

                  if (possibleLocalities && possibleLocalities.items && possibleLocalities.items.length > 0) {
                    handleSetOrganization(possibleLocalities[0]);
                  } else {
                    enqueueSnackbar("We couldn't find any organization near your location", {
                      variant: "error"
                    });
                  }

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }(), function (error) {
        enqueueSnackbar("Unable to get your location. ".concat(error.message), {
          variant: "error"
        });
      });
      setLoading(false);
    }; // Geolocation feature


    if (showGeolocation) {
      renderedListItems.push({
        listItems: [{
          itemIcon: /*#__PURE__*/_react.default.createElement(_GpsFixed.default, null),
          itemText: {
            primary: "Find Organizations Near Me"
          },
          button: true,
          onClick: handleUseCurrentLocation
        }]
      });
    } // Render the populated organizations


    renderedListItems.push({
      children: "",
      listItems: userOrganizationsFiltered.map(mapOrgButton)
    });

    if (recentLocations && recentLocations.length > 0) {
      renderedListItems.push({
        children: "Recent Organizations",
        listItems: recentLocations.map(mapRecentOrgButton)
      });
    }

    if (savedLocations && savedLocations.length > 0) {
      renderedListItems.push({
        children: savedLocationsHeader,
        listItems: savedLocations.map(mapOrgButton)
      });
    }
  } else {
    // If there is a search value present, render the search results
    renderedListItems.push({
      children: "Search Results",
      listItems: searchResults
    });
  }

  var popoverContent = /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 0
  }, (pageType === "public" || isSuperUser) && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    className: classes.contentWrapper
  }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
    startAdornment: /*#__PURE__*/_react.default.createElement(_Room.default, {
      className: classes.searchMapIcon
    }),
    placeholder: "Type an organization name...",
    id: "organization-search-form-control",
    autoFocus: true,
    fullWidth: true,
    value: searchValue,
    onChange: onSearchChange,
    searchOnChange: true
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_List.default, {
    id: "prmbl-OrgSwitcher-organizations",
    className: classes.list,
    "aria-label": "Organizations",
    subheaders: renderedListItems
  })), Boolean(isError) && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    className: classes.contentWrapper
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    color: "error",
    align: "center"
  }, isError)));

  var organizationInitialMessage = "Select an organization",
      newOrganizationMessage = "Select another organization";
  var popoverTitle = currentOrg ? newOrganizationMessage : organizationInitialMessage;
  var renderedOrganizationName = currentOrganization ? (0, _OrganizationHelper.formatOrgName)(currentOrganization, currentOrganization.name) : organizationInitialMessage;
  (0, _react.useEffect)(function () {
    setCurrentOrganization(currentOrg);
  }, [currentOrg]);
  (0, _react.useEffect)(function () {
    // To use for filtering the current org. from the org. listing
    if (modifyOrganizationOpen) {
      setTmpOrganization(currentOrganization);
    }
  }, [currentOrganization, modifyOrganizationOpen]);
  (0, _react.useEffect)(function () {
    if (searchValue !== "") debounceSearch(searchValue);
  }, [searchValue, debounceSearch]);
  (0, _react.useEffect)(function () {
    var handlePopulateOrgs = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var populateAvailableOrgs, orgsItems;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                setLoading(true);
                _context5.next = 3;
                return handleGetOrganizations({});

              case 3:
                populateAvailableOrgs = _context5.sent;

                if (populateAvailableOrgs && populateAvailableOrgs.items.length > 0) {
                  orgsItems = populateAvailableOrgs.items;

                  if (orgsItems.length === 1) {
                    setError("You only have access to the organization you have currently selected.");
                  }

                  setUserOrganizations(orgsItems);
                }

                setLoading(false);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function handlePopulateOrgs() {
        return _ref5.apply(this, arguments);
      };
    }();

    handlePopulateOrgs(); // Code running only in the first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: "change-organization",
    className: classes.root,
    variant: "text",
    title: "Change Organization",
    onClick: handleEditLocation,
    disabled: isLoading
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 1,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    className: classes.icon
  }, /*#__PURE__*/_react.default.createElement(_Room.default, null)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: "h1",
    variant: "h6"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_SkeletonLoader.default, {
    width: "150px"
  }) : renderedOrganizationName)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    className: classes.searchIcon
  }, /*#__PURE__*/_react.default.createElement(_Search.default, {
    fontSize: "small"
  })))), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: modifyOrganizationOpen && !isMobileView,
    onClose: handleCloseEditLocation,
    title: popoverTitle,
    classes: {
      dialogContent: classes.dialogContent
    },
    fullWidth: true,
    maxWidth: "sm"
  }, popoverContent), /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    open: modifyOrganizationOpen && isMobileView,
    onClose: handleCloseEditLocation,
    anchor: "bottom",
    classes: {
      paper: classes.drawer
    },
    id: "drawer-".concat(popoverTitle)
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: "h1",
    variant: "h6",
    className: classes.drawerHeader
  }, popoverTitle), popoverContent));
};

exports.OrgSwitcher = OrgSwitcher;
OrgSwitcher.defaultProps = {
  pageType: "admin"
};
var _default = OrgSwitcher;
exports.default = _default;